// src/features/reporting/services/inventoryAnalytics.js
import { apiClient } from '../../../services/api/client';

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') search.set(key, value);
  });
  const text = search.toString();
  return text ? `?${text}` : '';
};

// Inventory reports. Amounts are DKK incl. moms.
export const inventoryAnalyticsAPI = {
  // inventory:cost:read
  getValueHistory: ({ startDate, endDate, granularity, productGroupId } = {}) =>
    apiClient.get(`/api/v1/inventory/analytics/value-history${query({
      start_date: startDate, end_date: endDate, granularity, product_group_id: productGroupId,
    })}`),

  // inventory:cost:read
  getAbcAnalysis: ({ startDate, endDate, basis, productGroupId } = {}) =>
    apiClient.get(`/api/v1/inventory/analytics/abc${query({
      start_date: startDate, end_date: endDate, basis, product_group_id: productGroupId,
    })}`),

  // inventory:stock:read
  getCoRemoval: ({ startDate, endDate, windowMinutes, minCount } = {}) =>
    apiClient.get(`/api/v1/inventory/analytics/co-removal${query({
      start_date: startDate, end_date: endDate, window_minutes: windowMinutes, min_count: minCount,
    })}`),
};
